import { Box, Stack, Typography } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { Icons } from "../../../components/icons";

const CorporateCategoryCardList = ({ item, variant, CTAOnClick }) => {

  const [hide, setHide] = useState(true);
  const navigate = useNavigate();

  const cleanDescription = item?.description?.replace(/(<([^>]+)>)/gi, "") || "";
  const isLongDescription = cleanDescription.length > 250;


  const renderCTAButton = () => {

    return (
      <Typography
        variant="h5"
        style={{
          cursor: item?.display === false ? "not-allowed" : "pointer",
          height: "fit-content",
          padding: "4px 16px",
          margin: 24,
          minWidth: "150px",
          background: "linear-gradient(45deg, #03688C 0%, #08BED0 100%)",
          borderRadius: "16px",
          textAlign: "center",
          color: "#EAEAEB",
        }}
        noWrap
        onClick={
          item?.display === false
            ? null
            : () => {
              navigate(`/scenarios/details/${item.id}`, {
                state: { from: item?.id, type: item?.type_name },
              })
            }
        }
      >
        {item?.display === false ? (
          <Icons.lock
            style={{
              fontSize: 18, // Sets the size of the icon
              cursor: "not-allowed", // Indicates the element is disabled
              color: "#fff", // Sets the main color of the icon
              stroke: "#fff", // Ensures the stroke color matches the icon color
              strokeWidth: 1.4, // Sets the width of the stroke
              transition: "all 0.3s", // Smooth transition for hover effects
              filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))", // Adds a subtle shadow
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#ccc"; // Changes color on hover
              e.currentTarget.style.transform = "scale(1.3)"; // Slightly enlarges on hover
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#fff"; // Resets color when not hovering
              e.currentTarget.style.transform = "scale(1)"; // Resets size when not hovering
            }}
          />
        ) : (
          `Get ${item.points} Points`
        )}
      </Typography>
    );

  };

  return (
    <Stack
      direction="row"
      style={{
        maxHeight: "fit-content",
        justifyContent: "space-between",
        width: "100%",
        gap: 24,
        backgroundColor: "#16181F",
        borderRadius: "12px",
        marginBottom: 24,
        filter: item?.display === false && `blur(0.8px)`,
      }}
    >
      <Stack direction="row" sx={{ flex: 1, minWidth: 0 }}>
        {/* image */}
        <Box
          sx={{
            width: "255px",
            minWidth: "255px",
            maxWidth: "255px",
            height: "170px",
            minHeight: "170px",
            maxHeight: "170px",
            flexShrink: 0,
            alignSelf: "flex-start",
            overflow: "hidden",
            borderRadius: "12px 0 0 12px",
            backgroundColor: "#0d0e12",
          }}
        >
          <img
            src={item?.thumbnail_url}
            alt="image"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
        {/* details */}
        <Stack justifyContent="space-around" style={{ padding: 12 }} sx={{ flex: 1, minWidth: 0 }}>
          <Stack direction="row" alignItems="center" gap={2} marginVertical={2}>
            <Typography variant="h2">{item.name}</Typography>
            <Typography
              variant="body3"
              style={{
                color: "#BCBEC1 !important",
                backgroundColor: "#242833",
                borderRadius: "16px",
                height: "fit-content",
                padding: "4px 16px",
              }}
            >
              {item?.severity_name}
            </Typography>
            <Typography
              variant="body3"
              style={{
                color: "#BCBEC1 !important",
                backgroundColor: "#242833",
                borderRadius: "16px",
                height: "fit-content",
                padding: "4px 16px",
              }}
              noWrap
            >
              {item?.points} points
            </Typography>


            {item?.category_name && <Typography
              variant="body3"
              style={{
                color: "#BCBEC1 !important",
                backgroundColor: "#242833",
                borderRadius: "16px",
                height: "fit-content",
                padding: "4px 16px",
              }}
              noWrap
            >
              {item?.category_name}
            </Typography>}


            <Typography
              variant="body3"
              style={{
                color: "#BCBEC1 !important",
                backgroundColor: "#242833",
                borderRadius: "16px",
                height: "fit-content",
                padding: "4px 16px",
              }}
              noWrap
            >
              {item?.type_name}
            </Typography>

            {item?.ttx_enabled && <Typography
              variant="body3"
              style={{
                color: "#BCBEC1 !important",
                backgroundColor: "#242833",
                borderRadius: "16px",
                height: "fit-content",
                padding: "4px 16px",
              }}
              noWrap
            >
              {item?.ttx_enabled && "TTX enabaled"}
            </Typography>
            }
          </Stack>




          <Stack sx={{ width: "100%" }}>
            <Typography variant="h5" sx={{ color: "#BCBEC1 !important", wordBreak: 'break-word' }}>
              {isLongDescription && hide
                ? `${cleanDescription.substring(0, 250)}...`
                : cleanDescription}
            </Typography>
            {isLongDescription && (
              <Typography
                variant="h5"
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                  color: "#0FF",
                  marginTop: "4px",
                  width: "fit-content",
                }}
                onClick={() => setHide(!hide)}
              >
                {hide ? "Read More" : "Read Less"}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
      {/* points */}
      <Stack justifyContent="center" alignItems="center" sx={{ flexShrink: 0 }}>
        {renderCTAButton()}
      </Stack>
    </Stack>
  );
};

export default CorporateCategoryCardList;
